import React, { useContext, useEffect, useState } from "react";
import AccountClassSetupScroll from "./AccountClassSetupScroll";
import { accountService } from "../../services/accountService";
import { useForm } from "react-hook-form";
import AccountClassTypeSelect from "./AccountClassTypeSelect";
import LogicContext from "../../Context/LogicContext";
import GeneralModal from "../../helpers/GeneralModal";
import { createModal } from "react-modal-promise";
import { toLowercaseKeys } from "../../helpers/toLowerCaseKeys";


export default function AccountClassSetupPage() {
  const [currType, setCurrType] = useState(null);
    const logicContext = useContext(LogicContext);
      const myPromiseModal = createModal(GeneralModal);
    
  const [mainData, setMainData] = useState({account_main_info:[], account_type_info:[]});
  const { register, setValue, getValues, handleSubmit, reset, formState: { errors } } = useForm();



  useEffect(()=> {
    accountService.getAccountClass().then((res)=> {
        const serverData =toLowercaseKeys( res.data);
        if(serverData?.account_type_info?.length){
          setMainData(serverData);
        }
    }).catch((err)=> {
        console.log("error")
    })

},[]);


  const onSelectedItem = async (sel) => {
    setValue('account_main_id', sel?.account_main_id );
    setValue('account_type_id', sel?.account_type_id );
    setValue('account_type_name', sel?.account_type_name );
    setCurrType(sel);
    
  }

  const onSubmit = async () => {
    let formData = getValues();
    let option = 1;
    if(currType?.account_main_id){
      option = 2
;    }

    await myPromiseModal({
      title: "Create New Account Class", body: `${currType?.account_main_id ? "Account Class will be updated!" : "New Account Class will be created!"}`,
      showInput: false, placeHolder: '',
  }).then((res) => {
    if(res.decision === true){
      accountService.createNewAccountClass({...formData, option}).then((res)=> {
        const serverRes = res.data;
        // serverRes.account_type_info
        // serverRes.result_status
        const data =  logicContext.httpResponseManager(serverRes?.result_status[0]);
        if(data?.message_id == 1){
          if(serverRes.account_type_info?.length){
            setCurrType(null);
            reset();
            setMainData((prev)=> {
              return {...prev, account_type_info: serverRes.account_type_info}
            })
  
          }
          logicContext.showToast(data?.message_text, 'success');

        }

      });
    }
  });
  }

  const onDeleteAccountClass = async (account)=> {
    await myPromiseModal({
      title: `Delete ${account?.account_type_name}`, body: `Account will be deleted!`,
      showInput: false, placeHolder: '',
  }).then((res) => {
    if(res.decision === true){
      accountService.deleteAccountClass(account?.account_type_id).then((res)=> {
        const serverData =  res.data;
      })
    }

  });
  }


  const clearFormAction = () => {
    setCurrType(null);
    logicContext.showToast("Form is now clear...", 'info');
  }


  function onErrors(error) {
    console.error(errors);
    // logicContext.showToast("One or more value is required", "error");
  }

  const onMainAccSelect = (mainAcc) => {
    setValue('account_main_id', mainAcc?.account_main_id );
  }



  return (
    <div className="min-h-screen p-8 bg-white flex gap-6">
      {/* Left Scroll List */}
   
        <AccountClassSetupScroll list={mainData?.account_type_info} onSelectedItem={onSelectedItem} />
      {/* Main Content */}
      <div className="flex flex-col gap-6 flex-1">
        {/* Add Button */}
        <div>
          <button onClick={()=> clearFormAction()} className="rounded border  border-black px-4 py-2"> New Record</button>
        </div>
        {/* Form Section */}
        <form onSubmit={handleSubmit(onSubmit, onErrors)}>
        <div className="flex flex-col gap-6">
          <h3 className="bg-blue-50  p-3 m-3 font-bold" >{currType?.account_type_name} </h3>
          {/* Name Field */}
          <div className="flex items-center gap-4 w-60">
            <label className="">Name</label>
            <input  {...register("account_type_name", {
                              required: "Type Name is required!",
                            })}
             className=" border border-black p-2" placeholder="Name" /> <br/>
           <small className="text-danger">
                      {" "}
                      {errors?.account_type_name && errors.account_type_name.message}
                    </small>
          </div>
         

          {/* Type Field */}
          <div className="flex items-center gap-4 w-40">
            <label className="">Type</label>
            <AccountClassTypeSelect  {...register("account_main_id", {
                              required: "Main account is required!",
                            })}
             defaultVal={currType?.account_main_name} onMainAccSelect={onMainAccSelect} list={mainData?.account_main_info} />
            <small className="text-danger">
                      {" "}
                      {errors?.account_main_id && errors.account_main_id.message}
                    </small>
             
          </div>

     
          {/* Save Button */}
          <div className="pl-64">
            <button className="rounded border border-black bg-green-500 text-white px-6 py-2 m-2"> {currType?.account_main_id ? "Update" : "Save"} </button>

            {currType?.account_main_id &&  
            <button type="button" onClick={()=> onDeleteAccountClass(currType)} className="rounded border border-black btn-danger bg-red-500 text-white px-6 py-2 m-2">Delete</button>

            }
            <button onClick={()=> clearFormAction()} type="button" className="rounded border  border-black px-6 py-2 m-2">Cancel</button>
          </div>
        </div>
        </form>
      </div>
    </div>
  );
}
